const TYPE = 'SET_LANGUAGE';

const action = (code) => (dispatch) => dispatch({ type: TYPE, payload: code });

export { action, TYPE };
